class FBSubright {
  constructor(
    description,
    organizations,
    title,
    categoryIDs,
    rightsCategoryID,
    titleHash,
    descriptionHash
  ) {
    this.description = description;
    this.learnMores = [];
    this.organizations = organizations;
    this.title = title;
    this.categoryIDs = categoryIDs;
    this.rightsCategoryID = rightsCategoryID;
    this.titleHash = titleHash;
    this.descriptionHash = descriptionHash;
  }
}

export default FBSubright;
